type Handler = (payload: never) => void;

export class Emitter<Events extends object> {
  private handlers = new Map<keyof Events, Set<Handler>>();

  on<E extends keyof Events>(event: E, cb: (payload: Events[E]) => void): () => void {
    let set = this.handlers.get(event);
    if (!set) {
      set = new Set();
      this.handlers.set(event, set);
    }
    set.add(cb as Handler);
    return () => this.off(event, cb);
  }

  off<E extends keyof Events>(event: E, cb: (payload: Events[E]) => void): void {
    this.handlers.get(event)?.delete(cb as Handler);
  }

  emit<E extends keyof Events>(event: E, payload: Events[E]): void {
    const set = this.handlers.get(event);
    if (!set) return;
    for (const cb of [...set]) {
      try {
        (cb as (p: Events[E]) => void)(payload);
      } catch (err) {
        console.error('[AICommerce] event handler error', err);
      }
    }
  }

  clear(): void {
    this.handlers.clear();
  }
}
